import PropTypes from "prop-types";
import React from "react";
import "./Text.css";

const Text = (props) => {
	const {
		italic,
		strong,
		type,
		align,
		children,
		uppercase,
		size,
		weight,
		className,
		...rest
	} = props;
	const classNameDef = `Text 
	Text-align__${align}
	Text__${type}
	fontSize_${size}
	fontWeight_${weight}
	${italic ? "Text__italic" : ""}
	${strong ? "Text__strong" : ""}
	${uppercase ? "Text__uppercase" : ""}
	${className}
	`;
	return (
		<span className={classNameDef} {...rest}>
			{children}
		</span>
	);
};

Text.propTypes = {
	italic: PropTypes.bool,
	strong: PropTypes.bool,
	className: PropTypes.string,
	uppercase: PropTypes.bool,
	type: PropTypes.oneOf(["paragraph", "inline"]),
	align: PropTypes.oneOf(["left", "center", "right"]),
	size: PropTypes.oneOf([12, 14, 16, 18, 20, 24, 32, 48]),
	weight: PropTypes.oneOf([
		100,
		200,
		300,
		400,
		500,
		600,
		700,
		800,
		900,
		"normal",
		"bold",
		"bolder",
		"ligher"
	]),
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node)
	]).isRequired
};

Text.defaultProps = {
	italic: false,
	strong: false,
	type: "inline",
	uppercase: false,
	align: "left",
	size: 16,
	weight: "normal",
	className: ""
};

export default Text;
